import { render, staticRenderFns } from "./SessionList.vue?vue&type=template&id=b6a1bc6c"
import script from "./SessionList.vue?vue&type=script&lang=js"
export * from "./SessionList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports